export const LANGUAGE = {
  en: {
    supervisor: 'Supervisor',
    branch: 'Branch',
    department: 'Department',
	area: 'Area',
	equipment: 'Equipment',
	dateOfEvent: 'Date of Event',
	timeOfEvent: 'Time of Event',
	category: 'Category',
	categoryDesc: 'Example of Reporting for this Category',
	desc: 'Description',
	correctiveAction: 'Action Taken',
	nearMiss: 'Near Miss',
	nearMissType: 'Near Miss Type',
	headerText: 'S.I.T.E. Focus'
  },
  es: {
    supervisor: 'Supervisora',
    branch: 'Rama',
    department: 'Departamento',
	area: 'Área',
	equipment: 'Equipo',
	dateOfEvent: 'Fecha del evento',
	timeOfEvent: 'Hora del evento',
	category: 'Categoría',
	example: 'Ejemplo de informe para esta categoría',
	desc: 'Descripción',
	correctiveAction: 'Acciones tomadas',
	nearMiss: 'Casi fallar',
	nearMissType: 'Tipo de casi accidente',
	headerText: 'Enfoque del SITIO'	
  }
};


export const getLabels = (language) => LANGUAGE[language] ?? LANGUAGE['en'];